/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/pages/auth/AuthRoutes`, `src/pages/home/HomeRoutes`).
 */

import React from "react";
import { Redirect, Route, Switch, withRouter } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { useLastLocation } from "react-router-last-location";
import HomeRoutes from "../pages/home/HomeRoutes";
import ErrorsPage from "../pages/errors/ErrorsPage";
import LogoutPage from "../pages/auth/Logout";
import ConfirmarEmail from "../pages/auth/ConfirmarEmail";
import { LayoutContextProvider } from "../../_metronic";
import Layout from "../../_metronic/layout/Layout";
import * as routerHelpers from "./RouterHelpers";
import AuthRoutes from "../pages/auth/AuthRoutes";
import AtualizarSessao from "../components/AtualizarSessao";

export const Routes = withRouter((props) => {
	const lastLocation = useLastLocation();
	routerHelpers.saveLastLocation(lastLocation);
	const { isAuthorized, menuConfig, userLastLocation } = useSelector(
		({ auth, urls, builder: { menuConfig } }) => ({
			menuConfig,
			isAuthorized: auth.user != null,
			userLastLocation: routerHelpers.getLastLocation()
		}),
		shallowEqual
	);

	const rootRoute = isAuthorized
		? <Redirect from="/auth" to={userLastLocation} />
		: <Route exact path="/" component={AuthRoutes} />;

	const appRoute = isAuthorized
		? <Layout><AtualizarSessao /><HomeRoutes /></Layout>
		: <Route component={AuthRoutes} />;

	return (
		<LayoutContextProvider history={props.history} menuConfig={menuConfig}>
			<Switch>
				{rootRoute}

				<Route path="/error" component={ErrorsPage} />
				<Route path="/logout" component={LogoutPage} />
				<Route path="/verificar-email" component={ConfirmarEmail} />

				{appRoute}
			</Switch>
		</LayoutContextProvider>
	);
});
